import { gql } from 'apollo-angular';
import { ContentGenerationOutputFragment } from '@modules/funnels/shared/graphql/fragments/content-generation-output.fragment';

export const SendMessageToChatGPTDocument = gql`
  mutation sendMessageToChatGPT($input: GenerateContentInputGraphql!) {
    sendMessageToChatGPT(input: $input) {
      ...ContentGenerationOutput
    }
  }
  ${ContentGenerationOutputFragment}
`;
